import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  it: {
    "nav.home": "Home",
    "nav.gallery": "Galleria",
    "nav.rooms": "Stanze",
    "nav.experience": "Esperienze",
    "nav.booking": "Prenota",
    "nav.contact": "Contatti",
    "nav.login": "Accedi",
    "nav.logout": "Esci",
    "nav.dashboard": "Dashboard",
    "nav.book_now": "Prenota ora",

    "hero.headline_1": "La dimora",
    "hero.headline_2": "di Patty.",
    "hero.subtitle": "Un rifugio elegante tra le vette dell'Appennino abruzzese. Spazi luminosi, dettagli raffinati, l'autentica ospitalità di montagna.",
    "hero.cta_overline": "Verifica disponibilità",
    "hero.cta_label": "Scegli le tue date",
    "hero.stat_rating": "Rating ospiti",
    "hero.stat_reviews": "Recensioni",
    "hero.stat_nights": "Notti ospitate",

    "story.overline": "La nostra storia",
    "story.title_1": "Un'ospitalità",
    "story.title_2": "su misura.",
    "story.p1": "La dimora di Patty nasce dall'amore per Castel di Sangro e per l'Abruzzo autentico. Un luogo dove il calore della montagna incontra un'estetica contemporanea, a pochi minuti dalle piste di Roccaraso e dal Parco Nazionale d'Abruzzo.",
    "story.p2": "Spazi luminosi, arredi contemporanei, dettagli d'arte e materiali moderni. Un'attenzione sartoriale ai vostri desideri, dal cestino di benvenuto alle piccole cortesie che rendono unico ogni soggiorno.",
    "story.stat_surface": "Superficie",
    "story.stat_guests": "Ospiti max",
    "story.stat_bedrooms": "Camere",
    "story.stat_bathrooms": "Bagno",
    "story.price_from": "A partire da",
    "story.per_night": "/notte",

    "gallery.overline": "Galleria",
    "gallery.title": "Ogni angolo, una promessa.",
    "gallery.view_all": "Vedi tutta la galleria",
    "gallery.page_title": "Esplora ogni dettaglio",
    "gallery.page_subtitle": "Una raccolta visiva degli spazi e delle atmosfere che renderanno il vostro soggiorno indimenticabile.",
    "gallery.cat_all": "Tutte",
    "gallery.cat_exterior": "Esterni",
    "gallery.cat_bedrooms": "Camere",
    "gallery.cat_living": "Living",
    "gallery.cat_bath": "Bagno",
    "gallery.cat_interior": "Interni",
    "gallery.cat_atmosphere": "Atmosfere",

    "amenities.overline": "Servizi",
    "amenities.title_1": "Tutto",
    "amenities.title_2": "ciò che serve.",
    "amenities.desc": "Comfort essenziali e dettagli di lusso, pensati per ogni esigenza dei nostri ospiti più attenti.",

    "reviews.overline": "Ospiti",
    "reviews.title_1": "Parole dai",
    "reviews.title_2": "nostri ospiti.",
    "reviews.count": "127 recensioni",

    "cta.overline": "Vi aspettiamo",
    "cta.title_1": "Il vostro soggiorno",
    "cta.title_2": "inizia qui.",
    "cta.button": "PRENOTA IL TUO SOGGIORNO",

    "rooms.page_overline": "Spazi",
    "rooms.page_title": "Pianta dell'appartamento",
    "rooms.page_subtitle": "Un open space curato in ogni dettaglio: 65 mq di eleganza distribuita su due camere, zona giorno e bagno, nel cuore di Castel di Sangro.",
    "rooms.explore_overline": "Esplora",
    "rooms.explore_title": "Passa il mouse sulle stanze",
    "rooms.explore_desc": "La planimetria reale dell'appartamento: una distribuzione efficiente con due camere indipendenti, ampia zona giorno con cucina e bagno con doccia.",
    "rooms.explore_note": "Disposizione tratta dalla planimetria catastale.",
    "rooms.stat_surface": "65 mq totali",
    "rooms.stat_bedrooms": "2 camere",
    "rooms.stat_guests": "5 ospiti max",
    "rooms.stat_bathrooms": "1 bagno con doccia",
    "rooms.hovered_label": "Stanza selezionata",
    "rooms.cta": "CONTROLLA DISPONIBILITÀ",
    "rooms.space_label": "Spazio",

    "booking.page_overline": "Prenota",
    "booking.page_title": "Il tuo soggiorno",
    "booking.page_subtitle": "Verifica la disponibilità, seleziona le tue date e conferma in pochi click. Pagamento sicuro e conferma immediata.",
    "booking.location": "Castel di Sangro (AQ) · Abruzzo",
    "booking.rating": "4.9 · 127 recensioni",
    "booking.secure": "Pagamento sicuro",
    "booking.secure_desc": "Transazioni protette e crittografate",
    "booking.instant": "Conferma immediata",
    "booking.instant_desc": "Ricevi la conferma via email in tempo reale",
    "booking.capacity": "Capacità massima",

    "contact.page_overline": "Contatti",
    "contact.page_title": "Parliamone insieme",
    "contact.page_subtitle": "Siamo a vostra disposizione per qualsiasi richiesta. Vi risponderemo personalmente entro 24 ore.",
    "contact.where": "Dove siamo",
    "contact.phone": "Telefono",
    "contact.email": "Email",
    "contact.cin": "CIN — Codice Identificativo Nazionale",
    "contact.whatsapp_overline": "Risposta immediata",
    "contact.whatsapp_title": "Scrivici su WhatsApp",
    "contact.map_overline": "Dove trovarci",
    "contact.map_title": "La nostra posizione",
    "contact.map_directions": "Ottieni indicazioni",
    "contact.form_name": "Nome",
    "contact.form_email": "Email",
    "contact.form_phone": "Telefono",
    "contact.form_subject": "Oggetto",
    "contact.form_message": "Messaggio",
    "contact.form_submit": "INVIA MESSAGGIO",
    "contact.form_sending": "INVIO...",
    "contact.success": "Messaggio inviato! Ti risponderemo entro 24h.",
    "contact.error": "Errore nell'invio. Riprova.",

    "footer.desc": "Una casa vacanza nel cuore dell'Appennino abruzzese, a Castel di Sangro. Eleganza di montagna, accoglienza autentica, dettagli pensati per offrirvi un soggiorno indimenticabile tra le vette d'Abruzzo.",
    "footer.explore": "Esplora",
    "footer.contact": "Contatti",
    "footer.rights": "Tutti i diritti riservati.",

    "amenities.wifi": "Wi-Fi gratuito",
    "amenities.kitchen": "Cucina attrezzata",
    "amenities.tv": "TV smart",
    "amenities.heating": "Riscaldamento",
    "amenities.hairdryer": "Asciugacapelli",
    "amenities.courtesy": "Set di cortesia",
    "amenities.linen": "Lenzuola e asciugamani",
    "amenities.cleaning": "Pulizia inclusa",

    "details.overline": "I dettagli",
    "details.title_1": "Piccole attenzioni,",
    "details.title_2": "grande accoglienza.",
    "details.desc": "Ogni soggiorno inizia con un gesto di benvenuto. Un cestino di prodotti tipici, la macchina Nespresso con capsule già pronte, il set di cortesia, ciabattine brandizzate, dispenser eleganti, sigillo eco-igienizzato al check-in e piccoli tocchi d'arte che rendono la dimora davvero un rifugio su misura.",
    "details.welcome": "Cestino di benvenuto",
    "details.welcome_desc": "Fette dorate, biscotti, marmellate, miele, tè e camomilla — pronti per la vostra prima colazione.",
    "details.coffee": "Macchina Nespresso",
    "details.coffee_desc": "Espresso di qualità in ogni momento della giornata, con una selezione di capsule assortite.",
    "details.courtesy": "Set di cortesia",
    "details.courtesy_desc": "Prodotti da bagno curati e piccoli comfort per farvi sentire come a casa.",
    "details.art": "Tocchi d'arte",
    "details.art_desc": "Dettagli artistici e complementi scelti con cura, per una dimora dal carattere autentico.",
    "details.card": "Benvenuti in Dimora",
    "details.card_desc": "Un biglietto scritto per voi ad ogni check-in — perché ogni ospite conta.",
    "details.slippers": "Ciabattine brandizzate",
    "details.slippers_desc": "Ciabattine monouso con il logo della dimora e teli morbidissimi, sempre pronti in camera.",
    "details.dispenser": "Dispenser eleganti",
    "details.dispenser_desc": "Shampoo e body wash professionali nella doccia — niente sprechi, tutto ricaricabile.",
    "details.sanitized": "Igienizzazione eco",
    "details.sanitized_desc": "Sigillo ecologico sul WC ad ogni check-in: la certezza di un ambiente pulito e sanificato.",

    "room.camera_name": "Camera Matrimoniale",
    "room.camera_desc": "Camera elegante con letto matrimoniale, parete in resina effetto cemento, ampio armadio a specchio e dettagli artistici.",
    "room.camera_beds": "1 letto matrimoniale",
    "room.cameretta_name": "Cameretta",
    "room.cameretta_desc": "Camera con letto a castello, perfetta per famiglie con bambini o coppie di amici. TV e luce naturale generosa.",
    "room.cameretta_beds": "1 letto a castello",
    "room.cucina_name": "Cucina · Soggiorno",
    "room.cucina_desc": "Cucina completamente attrezzata aperta sul soggiorno. Tavolo da pranzo, divano, TV e ambiente luminoso.",
    "room.cucina_beds": "Zona giorno",
    "room.bagno_name": "Bagno",
    "room.bagno_desc": "Bagno raffinato con box doccia ampio, sanitari sospesi, doppia mobiletteria contenitiva, scaldasalviette e set di cortesia.",
    "room.bagno_beds": "Doccia & lavabo",
    "room.esterno_name": "L'edificio",
    "room.esterno_desc": "La palazzina che ospita la dimora, nel cuore di Castel di Sangro. Posizione strategica a pochi passi dal centro storico e dai collegamenti per Roccaraso.",
    "room.esterno_beds": "Esterno",
    "room.guests_suffix": "ospiti",
    "plan.camera_matr": "Camera matrimoniale",
    "plan.cameretta": "Cameretta",
    "plan.angolo": "Angolo",
    "plan.cottura": "cottura",
    "plan.soggiorno": "Soggiorno / Pranzo",
    "plan.depth": "profondità 5,0 m",
    "plan.living_area": "zona giorno",
    "plan.disimpegno": "Disimpegno",
    "plan.bagno": "Bagno",
    "plan.outdoor": "SPAZIO ESTERNO",
    "plan.entrance": "INGRESSO",

    "auth.back_to_site": "← Torna al sito",
    "auth.welcome_back": "Bentornati.",
    "auth.reserved_area": "Area riservata",
    "auth.reserved_sub": "Accedi per gestire prenotazioni e impostazioni.",
    "auth.login_title": "Accedi",
    "auth.login_sub": "Inserisci le tue credenziali per continuare.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.submit_login": "ACCEDI",
    "auth.loading": "ATTENDI...",
    "auth.or": "oppure",
    "auth.create_account": "Crea un account",
    "auth.demo": "Credenziali demo",
    "auth.register_title": "Crea il tuo account",
    "auth.register_sub": "Registrati per gestire le tue prenotazioni.",
    "auth.full_name": "Nome completo",
    "auth.phone": "Telefono",
    "auth.submit_register": "CREA ACCOUNT",
    "auth.already": "Hai già un account?",
    "auth.login_link": "Accedi",
    "auth.welcome_toast": "Benvenuto",
    "auth.register_success": "Account creato con successo",
    "auth.invalid_creds": "Credenziali non valide",
    "auth.register_error": "Errore nella registrazione",

    "dash.overline": "Pannello gestione",
    "dash.hello": "Buongiorno",
    "dash.sub": "Le prenotazioni sono ora gestite direttamente da Vikey. Da qui puoi consultare i messaggi ricevuti dal modulo Contatti del sito.",
    "dash.inbox_title": "Richieste dal sito",
    "dash.messages_received": "messaggi ricevuti",
    "dash.loading": "Caricamento...",
    "dash.no_requests_title": "Nessuna richiesta ancora",
    "dash.no_requests_sub": "I messaggi dal modulo Contatti appariranno qui.",
    "dash.load_error": "Errore caricamento richieste",

    "whatsapp.default_message": "Salve, vorrei avere informazioni su La dimora di Patty",
  },
  en: {
    "nav.home": "Home",
    "nav.gallery": "Gallery",
    "nav.rooms": "Rooms",
    "nav.experience": "Experience",
    "nav.booking": "Book",
    "nav.contact": "Contact",
    "nav.login": "Sign in",
    "nav.logout": "Sign out",
    "nav.dashboard": "Dashboard",
    "nav.book_now": "Book now",

    "hero.headline_1": "La dimora",
    "hero.headline_2": "di Patty.",
    "hero.subtitle": "An elegant retreat among the peaks of the Abruzzo Apennines. Bright spaces, refined details, and authentic mountain hospitality.",
    "hero.cta_overline": "Check availability",
    "hero.cta_label": "Choose your dates",
    "hero.stat_rating": "Guest rating",
    "hero.stat_reviews": "Reviews",
    "hero.stat_nights": "Nights hosted",

    "story.overline": "Our story",
    "story.title_1": "Tailored",
    "story.title_2": "hospitality.",
    "story.p1": "La dimora di Patty was born from a love for Castel di Sangro and authentic Abruzzo. A place where mountain warmth meets contemporary design, just minutes from the Roccaraso ski slopes and the Abruzzo National Park.",
    "story.p2": "Bright spaces, contemporary furnishings, artistic details and modern materials. A tailored attention to your every wish — from the welcome basket to the little courtesies that make every stay unique.",
    "story.stat_surface": "Surface",
    "story.stat_guests": "Max guests",
    "story.stat_bedrooms": "Bedrooms",
    "story.stat_bathrooms": "Bathroom",
    "story.price_from": "From",
    "story.per_night": "/night",

    "gallery.overline": "Gallery",
    "gallery.title": "Every corner, a promise.",
    "gallery.view_all": "View the full gallery",
    "gallery.page_title": "Explore every detail",
    "gallery.page_subtitle": "A visual collection of the spaces and atmospheres that will make your stay unforgettable.",
    "gallery.cat_all": "All",
    "gallery.cat_exterior": "Exteriors",
    "gallery.cat_bedrooms": "Bedrooms",
    "gallery.cat_living": "Living",
    "gallery.cat_bath": "Bathroom",
    "gallery.cat_interior": "Interiors",
    "gallery.cat_atmosphere": "Atmospheres",

    "amenities.overline": "Amenities",
    "amenities.title_1": "Everything",
    "amenities.title_2": "you'll need.",
    "amenities.desc": "Essential comforts and luxury details, curated for the most discerning guests.",

    "reviews.overline": "Guests",
    "reviews.title_1": "Words from",
    "reviews.title_2": "our guests.",
    "reviews.count": "127 reviews",

    "cta.overline": "We're waiting for you",
    "cta.title_1": "Your stay",
    "cta.title_2": "begins here.",
    "cta.button": "BOOK YOUR STAY",

    "rooms.page_overline": "Spaces",
    "rooms.page_title": "Apartment floor plan",
    "rooms.page_subtitle": "An open space designed in every detail: 65 sqm of elegance across two bedrooms, living area, and bathroom, in the heart of Castel di Sangro.",
    "rooms.explore_overline": "Explore",
    "rooms.explore_title": "Hover over the rooms",
    "rooms.explore_desc": "The real floor plan of the apartment: an efficient layout with two independent bedrooms, a spacious living area with kitchen, and a bathroom with shower.",
    "rooms.explore_note": "Layout based on the official cadastral floor plan.",
    "rooms.stat_surface": "65 sqm total",
    "rooms.stat_bedrooms": "2 bedrooms",
    "rooms.stat_guests": "5 guests max",
    "rooms.stat_bathrooms": "1 bath with shower",
    "rooms.hovered_label": "Selected room",
    "rooms.cta": "CHECK AVAILABILITY",
    "rooms.space_label": "Space",

    "booking.page_overline": "Book",
    "booking.page_title": "Your stay",
    "booking.page_subtitle": "Check availability, pick your dates and confirm in a few clicks. Secure payment and instant confirmation.",
    "booking.location": "Castel di Sangro (AQ) · Abruzzo",
    "booking.rating": "4.9 · 127 reviews",
    "booking.secure": "Secure payment",
    "booking.secure_desc": "Encrypted and protected transactions",
    "booking.instant": "Instant confirmation",
    "booking.instant_desc": "Receive your confirmation by email in real time",
    "booking.capacity": "Max capacity",

    "contact.page_overline": "Contact",
    "contact.page_title": "Let's talk",
    "contact.page_subtitle": "We're at your service for any request. We'll get back to you personally within 24 hours.",
    "contact.where": "Where we are",
    "contact.phone": "Phone",
    "contact.email": "Email",
    "contact.cin": "CIN — National Identification Code",
    "contact.whatsapp_overline": "Instant reply",
    "contact.whatsapp_title": "Message us on WhatsApp",
    "contact.map_overline": "Where to find us",
    "contact.map_title": "Our location",
    "contact.map_directions": "Get directions",
    "contact.form_name": "Name",
    "contact.form_email": "Email",
    "contact.form_phone": "Phone",
    "contact.form_subject": "Subject",
    "contact.form_message": "Message",
    "contact.form_submit": "SEND MESSAGE",
    "contact.form_sending": "SENDING...",
    "contact.success": "Message sent! We'll get back to you within 24h.",
    "contact.error": "Something went wrong. Please try again.",

    "footer.desc": "A holiday home in the heart of the Abruzzo Apennines, in Castel di Sangro. Mountain elegance, authentic hospitality, and details designed to make your stay among Abruzzo's peaks unforgettable.",
    "footer.explore": "Explore",
    "footer.contact": "Contact",
    "footer.rights": "All rights reserved.",

    "amenities.wifi": "Free Wi-Fi",
    "amenities.kitchen": "Fully equipped kitchen",
    "amenities.tv": "Smart TV",
    "amenities.heating": "Heating",
    "amenities.hairdryer": "Hairdryer",
    "amenities.courtesy": "Courtesy set",
    "amenities.linen": "Linen & towels",
    "amenities.cleaning": "Cleaning included",

    "details.overline": "The details",
    "details.title_1": "Little touches,",
    "details.title_2": "warmest welcome.",
    "details.desc": "Every stay begins with a gesture of welcome. A basket of Italian treats, the Nespresso machine with capsules ready to brew, the courtesy set, branded slippers, elegant dispensers, an eco-sanitized seal at check-in and small pieces of art — everything crafted to make this retreat truly tailored to you.",
    "details.welcome": "Welcome basket",
    "details.welcome_desc": "Rusks, biscuits, jam, honey, tea and camomile — everything ready for your first breakfast.",
    "details.coffee": "Nespresso machine",
    "details.coffee_desc": "Quality espresso any time of the day, with a curated selection of assorted capsules.",
    "details.courtesy": "Courtesy set",
    "details.courtesy_desc": "Refined bath products and small comforts to make you feel right at home.",
    "details.art": "Artistic touches",
    "details.art_desc": "Curated art details and complements — for a retreat with authentic character.",
    "details.card": "Welcome card",
    "details.card_desc": "A personal note waiting for you at every check-in — because every guest matters.",
    "details.slippers": "Branded slippers",
    "details.slippers_desc": "Disposable slippers with our house logo and premium soft towels — always ready in your room.",
    "details.dispenser": "Elegant dispensers",
    "details.dispenser_desc": "Professional shampoo and body wash in the shower — no waste, all refillable.",
    "details.sanitized": "Eco sanitized",
    "details.sanitized_desc": "Ecological seal on the WC at every check-in: the guarantee of a clean, sanitized space.",

    "room.camera_name": "Master Bedroom",
    "room.camera_desc": "Elegant bedroom with a double bed, concrete-effect resin wall, spacious mirrored wardrobe and artistic details.",
    "room.camera_beds": "1 double bed",
    "room.cameretta_name": "Second Bedroom",
    "room.cameretta_desc": "Room with a bunk bed, perfect for families with children or friends. TV and generous natural light.",
    "room.cameretta_beds": "1 bunk bed",
    "room.cucina_name": "Kitchen · Living",
    "room.cucina_desc": "Fully equipped kitchen open onto the living area. Dining table, sofa, TV and a bright, welcoming ambience.",
    "room.cucina_beds": "Living area",
    "room.bagno_name": "Bathroom",
    "room.bagno_desc": "Refined bathroom with a spacious shower box, wall-hung fixtures, dual storage cabinets, towel warmer and courtesy set.",
    "room.bagno_beds": "Shower & sink",
    "room.esterno_name": "The Building",
    "room.esterno_desc": "The building that hosts the retreat, in the heart of Castel di Sangro. Strategic location just steps from the historic centre and the connections to Roccaraso.",
    "room.esterno_beds": "Exterior",
    "room.guests_suffix": "guests",
    "plan.camera_matr": "Master bedroom",
    "plan.cameretta": "Second bedroom",
    "plan.angolo": "Kitchen",
    "plan.cottura": "corner",
    "plan.soggiorno": "Living / Dining",
    "plan.depth": "depth 5.0 m",
    "plan.living_area": "living area",
    "plan.disimpegno": "Corridor",
    "plan.bagno": "Bathroom",
    "plan.outdoor": "OUTDOOR SPACE",
    "plan.entrance": "ENTRANCE",

    "auth.back_to_site": "← Back to site",
    "auth.welcome_back": "Welcome back.",
    "auth.reserved_area": "Members area",
    "auth.reserved_sub": "Sign in to manage bookings and settings.",
    "auth.login_title": "Sign in",
    "auth.login_sub": "Enter your credentials to continue.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.submit_login": "SIGN IN",
    "auth.loading": "PLEASE WAIT...",
    "auth.or": "or",
    "auth.create_account": "Create an account",
    "auth.demo": "Demo credentials",
    "auth.register_title": "Create your account",
    "auth.register_sub": "Sign up to manage your bookings.",
    "auth.full_name": "Full name",
    "auth.phone": "Phone",
    "auth.submit_register": "CREATE ACCOUNT",
    "auth.already": "Already have an account?",
    "auth.login_link": "Sign in",
    "auth.welcome_toast": "Welcome",
    "auth.register_success": "Account created successfully",
    "auth.invalid_creds": "Invalid credentials",
    "auth.register_error": "Registration error",

    "dash.overline": "Management panel",
    "dash.hello": "Hello",
    "dash.sub": "Bookings are now handled directly by Vikey. From here you can review the messages received via the Contact form on the website.",
    "dash.inbox_title": "Website inquiries",
    "dash.messages_received": "messages received",
    "dash.loading": "Loading...",
    "dash.no_requests_title": "No inquiries yet",
    "dash.no_requests_sub": "Messages from the Contact form will appear here.",
    "dash.load_error": "Error loading inquiries",

    "whatsapp.default_message": "Hello, I'd like some information about La dimora di Patty",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ldp_lang") || "it");

  useEffect(() => {
    localStorage.setItem("ldp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => dict[lang]?.[key] || dict.it[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
